import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { EduNavbarComponent } from './edu-navbar/edu-navbar.component';
import { NavbarItemComponent } from './navbar-item/navbar-item.component';
import { ProfileButtonComponent } from './profile-button/profile-button.component';
import { RamadanHeaderComponent } from './ramadan-header/ramadan-header.component';
import { MatDividerModule } from '@angular/material/divider';
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { OnboardingFabModule } from '../teacher-onboarding/onboarding-fab/onboarding-fab.module';
import { HelpModule } from '../shared/help/help.module';


@NgModule({
  declarations: [
    ProfileButtonComponent,
    RamadanHeaderComponent,
    NavbarItemComponent,
    EduNavbarComponent
  ],
  imports: [
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonModule,
    BrowserModule,
    MatSnackBarModule,
    MatMenuModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatSidenavModule,
    RouterModule,
    CdkOverlayOrigin,
    MatDividerModule,
    OnboardingFabModule,
    HelpModule,
]
})
export class NavbarModule { }
